import { render, staticRenderFns } from "./ModuleStatGrid.vue?vue&type=template&id=2f06e691"
import script from "./ModuleStatGrid.vue?vue&type=script&lang=js"
export * from "./ModuleStatGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports